export default {
  namespaced: true,
  state: {
    isShowButtomElem: false,
    list: [],
    isShowSyaryoList: false,
    deleteId: '', // 削除車両ID
    editId: '', // 編集車両ID
    addVecleFlg: false,
  },
  mutations: {
    create(state, data) {},
    update(state, data) {
      // @TODO 更新処理
      state.list = data
    },
    destroy(state, data) {
      state.list = []
      state.deleteId = ''
      state.editId = ''
      state.isShowSyaryoList = false
      state.order = {}
    },
    setIsShowSyaryoList(state, flg) {
      state.isShowSyaryoList = flg
    },
    setDeleteId(state, id) {
      state.deleteId = id
    },
    setEditId(state, id) {
      state.editId = id
    },
    execAddVecle(state) {
      state.addVecleFlg = !state.addVecleFlg
    },
    // ボトム要素表示切り替え
    changeDisplayButtomElem(state, flg = true) {
      state.isShowButtomElem = flg
    },
  },
  actions: {},
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicle.js